// API End Points
import {
  getDisputeResolutionEndpoint,
  getDisputeListEndpoint,
  getDisputeFacetsEndpoint,
  getShipmentDetailsEndpoint,
  getDisputeFromSfdcEndpoint,
  getDisputeFromSfdcInvoiceEndpoint,
  getRelatedIsrFromSfdcEndpoint,
  getRelatedIsrFromSfdcInvoiceEndpoint,
  getIsrDetailsEndpoint,
  getAttachmentsFromSfdcEndpoint,
  createIsrEndpoint,
  updateIsrEndpoint,
  getCountryListEndpoint,
  getEmailActivitiesEndpoint,
  getEmailActivityContentEndpoint,
  getSapInvoiceDataEndpoint,
  disputeFieldConstantsEndpoint,
  getDisputeDetailsEndpoint,
  getDisputeAssigneeEndpoint,
  disputeFieldLookupsEndpoint,
  getVoiceDisputesEndpoint,
  createVoiceDisputeEndpoint,
  deleteVoiceDisputeEndpoint,
  updateContactDetailsEndpoint,
  updateVoiceDisputeEndpoint,
  createBulkVoiceDisputeEndpoint,
  getDisputeResolutionRulesEndpoint,
  getDisputeHistoryEndpoint,
  updateDisputeBulkEndpoint,
  getChargeCodeDataEndpoint,
  getDisputeResolutionStageEndpoint,
  getDisputeTraceRetryEndpoint,
  fetchCommentsEndpoint,
  getSFDCIndexListEndPoint,
  updateTenderEndPoint,
  updateBulkTenderEndPoint,
  saveCommentsEndpoint,
  saveBulkCommentsEndpoint,
  saveBulkSFDCCommentsEndpoint,
  getDisputeInvoiceEndpoint,
  createDisputeEndpoint,
  bulkDisputeEndPoint,
  getStatusDisputeBulkEndpoint,
  getAutoResolutionDetailsEndpoint,
  validateBulkDisputeEndPoint,
  createDisputeArchivedEndpoint,
  categoriesMenuItemEndpoint,
  getLiveDashboardEndpoint,
  autoAllocateCasesEndpoint,
  caseAllocationStatus,
  getEmailActivityContentFromQSREndPoint,
  getSurchargeEmailDetailsEndPoint,
  getLiveDashboardDataByBulkIdEndpoint,
  saveGamRequestDetailsEndpoint,
  getSfdcEmailListEndpoint,
  updateSummarizationCommentsEndpoint,
  loadVectorDetailsEndpoint,
  rephraseCommentEndpoint,
} from "@/config/apiEndPoints";

// Constants
import {
  APIGEE_CLIENT_KEY_DISPUTE,
  APIGEE_CLIENT_KEY_SFDC,
  APIGEE_CLIENT_KEY_DATA,
  APIGEE_CLIENT_KEY_ACCOUNT,
  constantFieldsforUpdateDispute,
} from "@/config/constant";
import { LOCATION_API_CONSUMER_KEY } from "../config/constant";
import { updateSummaryActionedEndpoint } from "../config/apiEndPoints";

// Dispute
const getDisputeResolutionStageList = (idToken, disputeStage, isRedisputed) => {
  return {
    method: "get",
    url: `${getDisputeResolutionStageEndpoint}/${disputeStage}`,
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
    params: {
      redisputed: isRedisputed,
    },
  };
};

const getDisputeResolutionRules = (
  idToken,
  currentStatus,
  isRedisputed,
  newStatus
) => {
  return {
    method: "get",
    url: getDisputeResolutionRulesEndpoint,
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
    params: {
      "current-status": currentStatus,
      redisputed: isRedisputed,
      ...(newStatus && { "new-status": newStatus }),
    },
  };
};

const getDisputeDetailsById = (ohpDisputeId, idToken) => {
  return {
    method: "get",
    url: getDisputeDetailsEndpoint(ohpDisputeId),
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};

const updateDisputeById = (ohpDisputeId, data, idToken) => {
  return {
    method: "patch",
    url: getDisputeDetailsEndpoint(ohpDisputeId),
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
    data,
  };
};

const getDisputeList = ({ params, data }, idToken) => {
  return {
    method: "post",
    url: getDisputeListEndpoint,
    params: {
      page_no: params.page_no,
      page_size: params.page_size,
      search: params.search,
    },
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
    data,
  };
};

const getDisputeFacet = ({ params, data, property_id }, idToken) => {
  return {
    method: "post",
    url: getDisputeFacetsEndpoint(property_id),
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
    params,
    data,
  };
};

// Dispute Details Info
const getShipmentDetailsForDisputeCaseById = (ohpDisputeId, idToken) => {
  return {
    method: "get",
    url: getShipmentDetailsEndpoint(ohpDisputeId),
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DATA,
    },
  };
};

const getDisputeFromSfdc = (sfdcCaseId, idToken, invoiceNumber) => {
  return {
    method: "get",
    url: sfdcCaseId
      ? getDisputeFromSfdcEndpoint(sfdcCaseId)
      : getDisputeFromSfdcInvoiceEndpoint(invoiceNumber),
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_SFDC,
    },
  };
};

const getAutoResolutionDetails = (invoiceNumber, idToken) => {
  return {
    method: "get",
    url: getAutoResolutionDetailsEndpoint(invoiceNumber),
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DATA,
    },
  };
};

const getRelatedIsrFromSfdc = (idToken, invoiceNumber) => {
  return {
    method: "get",
    url: getRelatedIsrFromSfdcInvoiceEndpoint(invoiceNumber),
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_SFDC,
    },
  };
};

const getIsrDetails = (id, idToken) => {
  return {
    method: "get",
    url: getIsrDetailsEndpoint(id),
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_SFDC,
    },
  };
};

const getAttachmentsFromSfdc = (id, idToken) => {
  return {
    method: "get",
    url: getAttachmentsFromSfdcEndpoint(id),
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_SFDC,
    },
  };
};

const createIsr = (data, idToken) => {
  return {
    method: "post",
    url: createIsrEndpoint(),
    data,
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_SFDC,
    },
  };
};

const updateIsr = (id, data, idToken) => {
  return {
    method: "patch",
    url: updateIsrEndpoint(id),
    data,
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_SFDC,
    },
  };
};

const getCountryList = (searchTerm) => {
  return {
    method: "get",
    url: getCountryListEndpoint(searchTerm),
    headers: {
      accept: "application/json",
      "Consumer-Key": LOCATION_API_CONSUMER_KEY,
    },
  };
};
const getEmailActivities = (id, idToken) => {
  return {
    method: "get",
    url: getEmailActivitiesEndpoint(id),
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_SFDC,
    },
  };
};

const getEmailActivityContent = (id, idToken) => {
  return {
    method: "get",
    url: getEmailActivityContentEndpoint(id),
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_SFDC,
    },
  };
};

const getEmailActivityContentFromQSR = (id, idToken, nextLink) => {
  return {
    method: "get",
    url: getEmailActivityContentFromQSREndPoint(id, nextLink),
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_ACCOUNT,
    },
  };
};

const getSurchargeEmailDetails = (id, idToken) => {
  return {
    method: "get",
    url: getSurchargeEmailDetailsEndPoint(id),
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_ACCOUNT,
    },
  };
};

const getSfdcEmailList = (id, idToken) => {
  return {
    method: "get",
    url: getSfdcEmailListEndpoint(id),
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_SFDC,
    },
  };
};

const getDisputeInvoiceDetailsFromSap = (
  idToken,
  invoiceNumber,
  skip = 0,
  top = 2000
) => {
  return {
    method: "get",
    url: getSapInvoiceDataEndpoint,
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
    params: {
      Invoices: invoiceNumber,
      skip,
      top,
    },
  };
};

const getDisputeDetailsFromInvoiceId = (
  idToken,
  invoiceNumber,
  pageNo,
  pageSize
) => {
  return {
    method: "get",
    url: `${getDisputeInvoiceEndpoint}?searchType=INVOICE_NUMBER&values=${invoiceNumber}&page_no=${pageNo}&page_size=${pageSize}`,
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};

const createDisputeFromSfdc = (data, idToken) => {
  return {
    method: "post",
    url: createDisputeEndpoint,
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
    data,
  };
};

const createDisputeArchived = (data, idToken) => {
  return {
    method: "post",
    url: createDisputeArchivedEndpoint,
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
    data,
  };
};

const updateDisputeFromSfdc = (data, disputeId, idToken) => {
  return {
    method: "patch",
    url: `${createDisputeEndpoint}/${disputeId}`,
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
    data,
  };
};
const bulkDisputeCreate = (data, idToken) => {
  return {
    method: "post",
    url: bulkDisputeEndPoint,
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
      accept: "application/vnd.ohp.dispute.v2+json",
    },
    data,
  };
};
const validateBulkDispute = (data, idToken) => {
  return {
    method: "post",
    url: validateBulkDisputeEndPoint,
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
    data,
  };
};
const bulkDisputeUpdate = (data, idToken) => {
  return {
    method: "patch",
    url: bulkDisputeEndPoint,
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
    data,
  };
};

const getStatusBulkDispute = (bulkCreateID, idToken) => {
  return {
    method: "get",
    url: getStatusDisputeBulkEndpoint,
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
      "bulk-id": bulkCreateID,
    },
  };
};

const disputeFieldConstants = (idToken) => {
  return {
    method: "get",
    url: `${disputeFieldConstantsEndpoint}`,
    params: {
      fieldNames: constantFieldsforUpdateDispute,
    },
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DATA,
    },
  };
};

const disputeFieldLookups = (idToken, fields, searchKey) => {
  return {
    method: "get",
    url: `${disputeFieldLookupsEndpoint}`,
    params: {
      fieldNames: fields,
      pageSize: 319,
      searchTerm: searchKey || "",
    },
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DATA,
    },
  };
};

const getChargeCodeDropdownValues = (idToken, searchKey) => {
  return {
    method: "get",
    url: `${getChargeCodeDataEndpoint}`,
    params: {
      fieldNames: "CHARGE_CODE",
      pageSize: 700,
      searchTerm: searchKey || "",
    },
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};

const updateAssigneeDisputeDetails = (data, idToken) => {
  return {
    method: "post",
    url: getDisputeAssigneeEndpoint,
    data: data,
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};

const updateResolutionDisputeDetails = (ohpDisputeId, data, idToken) => {
  return {
    method: "patch",
    url: getDisputeResolutionEndpoint(ohpDisputeId),
    data,
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};

const updateTender = (ohpDisputeId, data, idToken) => {
  return {
    method: "put",
    url: updateTenderEndPoint(ohpDisputeId),
    data: data,
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};

const updateBulkTender = (data, idToken) => {
  return {
    method: "patch",
    url: updateBulkTenderEndPoint,
    data: data,
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};

const getVoiceDisputes = (ohpDisputeId, idToken) => {
  return {
    method: "get",
    url: getVoiceDisputesEndpoint(ohpDisputeId),
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};

const createVoiceDisputes = (ohpDisputeId, data, idToken) => {
  return {
    method: "post",
    url: createVoiceDisputeEndpoint(ohpDisputeId),
    data,
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};

const updateVoiceDispute = (data, idToken) => {
  return {
    method: "patch",
    url: updateVoiceDisputeEndpoint(data.ohpDisputeId, data.ohpDisputeVoiceId),
    data,
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};

const deleteVoiceDispute = (data, idToken) => {
  return {
    method: "delete",
    url: deleteVoiceDisputeEndpoint(data.ohpDisputeId, data.ohpDisputeVoiceId),
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};

const updateContactDetails = (ohpDisputeId, data, idToken) => {
  return {
    method: "patch",
    url: updateContactDetailsEndpoint(ohpDisputeId),
    data,
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};

const createBulkVoiceDisputes = (data, idToken) => {
  return {
    method: "post",
    url: createBulkVoiceDisputeEndpoint,
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
    data,
  };
};

const getDisputeHistory = (ohpDisputeId, idToken, historyType) => {
  return {
    method: "get",
    url: getDisputeHistoryEndpoint(ohpDisputeId),
    params: {
      entityName: historyType,
    },
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};

const updateBulkDisputes = (data, idToken) => {
  return {
    method: "patch",
    url: updateDisputeBulkEndpoint,
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
    data,
  };
};

const getDisputeTraces = (ohpDisputeId, idToken) => {
  return {
    method: "get",
    url: `${getDisputeDetailsEndpoint(ohpDisputeId)}/trace`,
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};

const getDisputeTraceRetry = (processId, idToken) => {
  return {
    method: "post",
    url: `${getDisputeTraceRetryEndpoint}${processId}/complete?isRetry=true`,
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};

const fetchComments = (ohpDisputeId, idToken, pageSize, pageNo) => {
  return {
    method: "get",
    url: fetchCommentsEndpoint(ohpDisputeId, pageSize, pageNo),
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};

// SFDC Index APIs
const getSFDCIndexList = (requestPayload, idToken) => {
  return {
    method: "get",
    url: getSFDCIndexListEndPoint,
    data: requestPayload,
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};

// Comments Post Api
const saveComments = (ohpDisputeId, isExternal, payload, idToken) => {
  return {
    method: "post",
    url: saveCommentsEndpoint(ohpDisputeId, isExternal),
    data: payload,
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};

//Update CommentsSummarization api

const updateSummarizationComments = async (
  ohpDisputeId,
  commentId,
  payload,
  idToken
) => {
  return {
    method: "put",
    url: updateSummarizationCommentsEndpoint(ohpDisputeId, commentId),
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
    data: payload,
  };
};

//API to Load Details into Vector DB
const updateVectorDetails = async (payload, idToken) => {
  return {
    method: "post",
    url: loadVectorDetailsEndpoint,
    headers: {
      Authorization: idToken,
    },
    data: payload,
  };
};

//API to call AI for Rephrasing Comment
const rephraseComment = async (payload, idToken) => {
  return {
    method: "post",
    url: rephraseCommentEndpoint,
    headers: {
      Authorization: idToken,
    },
    data: payload,
  };
};

// Comments Bulk Post Api
const saveBulkComments = (payload, isExternal, idToken) => {
  return {
    method: "post",
    url: saveBulkCommentsEndpoint(isExternal),
    data: payload,
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};

const saveGamRequestDetails = (payload, idToken) => {
  return {
    method: "post",
    url: saveGamRequestDetailsEndpoint(),
    data: payload,
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};

// Sfdc comments Bulk Post Api
const saveBulkSFDCComments = (payload, idToken) => {
  return {
    method: "post",
    url: saveBulkSFDCCommentsEndpoint,
    data: payload,
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
      accept: "application/vnd.ohp.dispute.v1+json",
    },
  };
};
const getCategoriesMenuItem = (
  itemCategoryDescription,
  product,
  linOfBusiness,
  idToken
) => {
  return {
    method: "get",
    url: categoriesMenuItemEndpoint(
      itemCategoryDescription,
      product,
      linOfBusiness
    ),
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_ACCOUNT,
    },
  };
};

const getLiveDashboardData = (
  view,
  countryName,
  areaName,
  reasonDescription,
  fromDate,
  toDate,
  idToken
) => {
  return {
    method: "get",
    url: getLiveDashboardEndpoint(
      view,
      countryName,
      areaName,
      reasonDescription,
      fromDate,
      toDate
    ),
    headers: {
      Authorization: `${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};

const getLiveDashboardDataByBulkId = (bulkId, idToken) => {
  return {
    method: "get",
    url: getLiveDashboardDataByBulkIdEndpoint(bulkId),
    headers: {
      Authorization: `${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};
// Auto Allocate cases
const assignAutoAllocateCases = (apmId, numberOfCaseCount, idToken) => {
  return {
    method: "get",
    url: autoAllocateCasesEndpoint(apmId, numberOfCaseCount),
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};

// Auto Allocate cases
const getAutoAllocateStatus = (apmId, idToken) => {
  return {
    method: "get",
    url: caseAllocationStatus(apmId),
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};

const updateSummaryActioned = (ohpDisputeId, data, idToken) => {
  return {
    method: "patch",
    url: updateSummaryActionedEndpoint(ohpDisputeId),
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
    data,
  };
};

export default {
  getDisputeDetailsById,
  getDisputeList,
  getDisputeFacet,
  getShipmentDetailsForDisputeCaseById,
  getDisputeFromSfdc,
  getRelatedIsrFromSfdc,
  getIsrDetails,
  getAttachmentsFromSfdc,
  createIsr,
  updateIsr,
  getCountryList,
  getEmailActivities,
  getEmailActivityContent,
  getDisputeInvoiceDetailsFromSap,
  disputeFieldConstants,
  updateDisputeById,
  updateResolutionDisputeDetails,
  updateAssigneeDisputeDetails,
  disputeFieldLookups,
  getVoiceDisputes,
  createVoiceDisputes,
  updateContactDetails,
  deleteVoiceDispute,
  updateVoiceDispute,
  createBulkVoiceDisputes,
  getDisputeResolutionRules,
  getDisputeHistory,
  updateBulkDisputes,
  getDisputeTraces,
  getChargeCodeDropdownValues,
  getDisputeResolutionStageList,
  getDisputeTraceRetry,
  fetchComments,
  getSFDCIndexList,
  updateTender,
  updateBulkTender,
  saveComments,
  saveBulkComments,
  getDisputeDetailsFromInvoiceId,
  createDisputeFromSfdc,
  updateDisputeFromSfdc,
  bulkDisputeCreate,
  bulkDisputeUpdate,
  saveBulkSFDCComments,
  getStatusBulkDispute,
  getAutoResolutionDetails,
  validateBulkDispute,
  createDisputeArchived,
  getCategoriesMenuItem,
  getLiveDashboardData,
  assignAutoAllocateCases,
  getAutoAllocateStatus,
  getEmailActivityContentFromQSR,
  getSurchargeEmailDetails,
  getLiveDashboardDataByBulkId,
  getSfdcEmailList,
  saveGamRequestDetails,
  updateSummarizationComments,
  updateVectorDetails,
  rephraseComment,
  updateSummaryActioned,
};
